import {SCHEMA_NAME} from './constant'
export function getSelectedWidget(selection) {
  const viewElement = selection.getSelectedElement();

  if (viewElement && isFlowWidget(viewElement)) {
    return viewElement;
  }

  return null;
}

export function isFlowWidget(viewElement) {
  return (
    !!viewElement && viewElement.name==SCHEMA_NAME
  );
}